import { render, staticRenderFns } from "./JGrid.vue?vue&type=template&id=68eabede&"
import script from "./JGrid.vue?vue&type=script&lang=js&"
export * from "./JGrid.vue?vue&type=script&lang=js&"
import style0 from "./JGrid.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports